import React, { useState } from 'react';
import { Header } from '../../common/header.component';
import { Rbac } from '../../common/Rbac';
import { CleanUser, RbacObject } from '../../../export-types/cleaned-types';
import { NavLink, Outlet, useLocation } from 'react-router-dom';
import { ModalsService } from '../../../services/modals.service';
import { AddUserModal } from './add-user-modal.component';
import { useGlobalMutate } from '../../../api/useGlobalMutate';
import Dropdown from 'rsuite/Dropdown';
import { AlertService } from '../../../services/alert.service';
import { useIntl } from 'react-intl';
import { LinkUserModal } from './link-user-model.component';
import { UnLinkUserModal } from './unlink-user-model.component';

export type UserProps = CleanUser & {
  moneyBill: { cny: number; usd: number };
  deliveryDebt: number | null;
};

export type OutletContextParams = {
  selectedOrders: Set<string>;
  setSelectedOrders: React.Dispatch<React.SetStateAction<Set<string>>>;
  isSelectAll: boolean;
  selectAll: React.Dispatch<React.SetStateAction<boolean>>;
  isUnselectAll: boolean;
  unselectAll: React.Dispatch<React.SetStateAction<boolean>>;
};

export const UsersScreen = () => {
  const { mutate } = useGlobalMutate();
  const intl = useIntl();
  const { pathname } = useLocation();
  const addUser = () => {
    ModalsService.createModal(AddUserModal, { mutate });
  };

  const path = pathname.split('/')[2];
  const [selectedOrders, setSelectedOrders] = useState<Set<string>>(new Set());
  const [isSelectAll, selectAll] = useState(false);
  const [isUnselectAll, unselectAll] = useState(false);

  const context: OutletContextParams = {
    selectedOrders,
    setSelectedOrders,
    isSelectAll,
    selectAll,
    isUnselectAll,
    unselectAll,
  };

  return (
    <>
      <Header>
        <div className="d-flex flex-row align-items-center">
          <h1>Пользователи</h1>
          <Rbac object={RbacObject.User} action={'write:admin'}>
            <div className="ps-4">
              <div className="btn btn-success" onClick={addUser}>
                <i className="bi bi-plus-circle-fill me-2" />
                Добавить
              </div>
            </div>
            {path === 'clients' && (
              <div className="ps-4" style={{ zIndex: 50 }}>
                <Dropdown
                  toggleClassName="btn btn-success"
                  placement="bottomEnd"
                  title={intl.formatMessage({
                    defaultMessage: 'Команды',
                    id: 'orders.btn-label.comands',
                    description: 'Кнопка',
                  })}
                >
                  <Dropdown.Item
                    onSelect={() => {
                      ModalsService.createModal(LinkUserModal, {
                        orderIds: Array.from(selectedOrders),
                        setSelectedOrders: setSelectedOrders,
                      }).then(() => {
                        mutate();
                      });
                    }}
                  >
                    <span className="ps-2">Привязать</span>
                  </Dropdown.Item>
                  <Dropdown.Item
                    onSelect={() => {
                      ModalsService.createModal(UnLinkUserModal, {
                        orderIds: Array.from(selectedOrders),
                        setSelectedOrders: setSelectedOrders,
                      }).then(() => {
                        mutate();
                      });
                    }}
                  >
                    <span className="ps-2">Отвязать</span>
                  </Dropdown.Item>
                </Dropdown>
              </div>
            )}
          </Rbac>
        </div>
      </Header>
      <div className="d-flex flex-row">
        <ul className="nav nav-pills mb-4">
          <li className="nav-item">
            <NavLink
              to="/users/clients"
              className="nav-link text-decoration-none"
            >
              Клиенты
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink
              to="/users/employees"
              className="nav-link text-decoration-none"
            >
              Сотрудники
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink
              to="/users/temp-access-sessions/all"
              className="nav-link text-decoration-none"
            >
              Временные права
            </NavLink>
          </li>
          <Rbac object={RbacObject.FeatureFlag} action={'read:admin'}>
            <li className="nav-item">
              <NavLink
                to="/users/feature-flags"
                className="nav-link text-decoration-none"
              >
                Фича флаги
              </NavLink>
            </li>
          </Rbac>
        </ul>
      </div>
      <Outlet context={context} />
    </>
  );
};
